import type { ReactNode } from "react";

import { Container } from "@/design-system/Container";
import { Grid, GridItem } from "@/design-system/Grid";

interface CommunityContentRailProps {
  children: ReactNode;
}

/** Product-owned two-thirds rail shared by community editors and rich content. */
export function CommunityContentRail({ children }: CommunityContentRailProps): ReactNode {
  return (
    <Container fullWidth>
      <Grid>
        <GridItem span={{ base: 12, container: { md: 8 } }}>{children}</GridItem>
      </Grid>
    </Container>
  );
}
